var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-rect"},[_c('div',{ref:"scrollContent",staticClass:"scroll-content",class:{
      'flow-text': _vm.flowText,
      'flex-height': _vm.flex,
      flex: _vm.flex,
      'flex-col': _vm.flex,
      'overflow-x-hidden': _vm.scroll,
      'overflow-y-auto': _vm.scroll,
      'overflow-hidden': !_vm.scroll && !_vm.overflowVisible,
      'overflow-visible': !_vm.scroll && _vm.overflowVisible
    },on:{"scroll":_vm.onScroll}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }